module.exports = __webpack_public_path__ + "img/laboratorio_9-16_1620.3ca20e47.jpg";